import api from './client';

export interface WarehouseStockRow {
  unit: string;
  in_stock: number;
  to_ship: number;
  available: number;
}

export interface WarehousePackageRow {
  item_id: string;
  item_name: string;
  volume: number | null;
  unit: string | null;
  package_label: string;
  article: string | null;
  purchase_price: number | null;
  sale_price: number | null;
  in_stock: number | null;
  to_ship: number | null;
  available: number | null;
  is_marked: boolean;
  marks_count: number | null;
  inactive: boolean;
}

export interface WarehouseLiquidRow {
  key: string;
  item_id: string;
  item_name: string;
  display_name: string;
  brand: string | null;
  model_name: string | null;
  catalog_id: number | null;
  article: string | null;
  unit_name: string | null;
  linked: boolean;
  is_liquid: boolean;
  legacy_ml: boolean;
  is_marked: boolean;
  marks_count: number;
  stocks: WarehouseStockRow[];
  packages: WarehousePackageRow[];
  packages_hidden: number;
}

export interface WarehouseBalanceRow {
  warehouse_id: string;
  warehouse_name: string;
  unit: string;
  in_stock: number;
  to_ship: number;
  available: number;
}

export interface WarehouseOneCItem {
  item_id: string;
  item_name: string;
}

export interface WarehouseLiquidCard {
  display_name: string;
  brand: string | null;
  catalog_id: number | null;
  is_marked: boolean;
  marks_count: number;
  warehouse_id: string;
  warehouse_name: string;
  balances: WarehouseBalanceRow[];
  packages: WarehousePackageRow[];
  packages_hidden: number;
  onec_items: WarehouseOneCItem[];
}

export interface WarehouseLiquidsResponse {
  synced_at: string | null;
  warehouse_id: string;
  warehouse_name: string;
  rows: WarehouseLiquidRow[];
}

export const getWarehouseLiquids = (): Promise<WarehouseLiquidsResponse> =>
  api.get<WarehouseLiquidsResponse>('/warehouse/liquids').then(r => r.data);

export const syncWarehouseLiquids = (): Promise<{ synced: number; synced_at: string }> =>
  api.post<{ synced: number; synced_at: string }>('/warehouse/liquids/sync').then(r => r.data);

export const getWarehouseLiquidCard = (
  params: { catalog_id: number } | { item_id: string },
): Promise<WarehouseLiquidCard> =>
  api.get<WarehouseLiquidCard>('/warehouse/liquids/card', { params }).then(r => r.data);

// Rev. 23: марки на складе (ready + reserved) по позиции 1С или карточке каталога
export interface WarehouseMarkItem {
  marking_code: string;
  raw_code: string | null;
  status: string;
  product_type: string;
  total_volume: number | null;
  bulk_remaining_volume: number | null;
}

export const getWarehouseMarks = (
  params: { catalog_id: number } | { item_id: string },
): Promise<WarehouseMarkItem[]> =>
  api.get<{ marks: WarehouseMarkItem[] }>('/warehouse/liquids/marks', { params }).then(r => r.data.marks);

export const getWarehouseDataMatrixSvg = (code: string, scale = 2): Promise<string> =>
  api.get('/warehouse/liquids/marks/datamatrix.svg', { params: { code, scale }, responseType: 'blob' })
    .then(r => URL.createObjectURL(r.data));
